// extracted by mini-css-extract-plugin
export default {"Container":"BroadCastBadge_Container__XedNH"};